module.exports = __webpack_public_path__ + "static/media/vjit-logo.719a4c4e.png";